import { useDispatch, useSelector } from "react-redux";
import Col from "../element/col";
import Row from "../element/row";
import Title from "./common.title";
import Container from "../element/container";
import Image from "../element/image";
import Icon from "../element/icon";
import formatNumber from "../../helpers/format.number";
import { useLocation, useNavigate } from "react-router-dom";
import { Sample } from "../../assets/images";
import { addCart } from "../../redux/reducer/cart.reducer";
import { toast } from "react-toastify";
import { showToast } from "../../helpers/show.toast";
import { Skeleton } from "primereact/skeleton";
import useWindowDimension from "../hook/use.window.dimension";

export default function CommonProduct({ className, product, key, loading }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { width } = useWindowDimension();
  const { pathname } = useLocation();

  const handleNavigate = (id, page) => {
    if (id) {
      navigate(`/product/${id}`, { state: pathname });
    } else {
      navigate(page);
    }
  };

  const handleAddCart = (id) => {
    // dispatch(
    //   addCart({
    //     id: id,
    //   })
    // )
    //   .unwrap()
    //   .then((res) => {
    //     showToast(
    //       "Added to Cart!",
    //       "The item has been added to your cart.",
    //       "success"
    //     );
    //   });
  };

  return (
    <Col
      className={`common-product ${className ?? ""} pointer`}
      key={key}
      onClick={() => handleNavigate(product.id)}
    >
      {loading ? (
        <Skeleton className="product-bg" />
      ) : (
        <article
          className={`product-bg ${
            product.quantity === 0 ? "--sold-out" : ""
          } relative`}
        >
          {product.quantity === 0 && (
            <Row className="_row sold-out">
              <p>Sold Out</p>
            </Row>
          )}
          <Image
            className="_img"
            src={product.media?.length > 0 ? product.media[0].url : Sample}
          />
        </article>
      )}
      <Row
        className={`mt-4 flex justify-between flex-nowrap gap-4 px-${
          width > 500 ? 3 : 1
        }`}
      >
        <Col className="_col product-label">
          {loading ? (
            <>
              <Skeleton
                width={width < 850 ? "140px" : width < 991 ? "160px" : "180px"}
                height={width < 850 ? "14px" : width < 991 ? "16px" : "18px"}
                borderRadius="0"
              />
              <Skeleton
                width={width < 991 ? "70px" : width < 991 ? "80px" : "90px"}
                height={width < 991 ? "16px" : width < 991 ? "18px" : "18px"}
                borderRadius="0"
              />
            </>
          ) : (
            <>
              <h4 className="_label product-title">{product.name?.name}</h4>
              <h3 className="_label product-price">
                RM {formatNumber(product.price, "range")}
              </h3>
            </>
          )}
        </Col>
        {loading ? (
          <Skeleton width="35px" height="35px" borderRadius="100%" />
        ) : (
          <Col
            className="_col product-icon"
            // onClick={(e) => {
            //   e.stopPropagation();
            //   handleAddCart(product.id);
            // }}
          >
            <Icon
              icon="hugeicons:shopping-basket-add-03"
              className="_svg add-cart"
            />
          </Col>
        )}
      </Row>
    </Col>
  );
}
